<template>
  <div class="sa-col-lg7 sa-col-md6  sa-col-sm7 sa-col-xs7">
    <apexchart type="bar" height="180" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  props:['rateBar'],
  components: {
      apexchart: VueApexCharts,
  },
data() {
    return {
        series: [{
          name: 'Reviews',
          data: this.rateBar
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 350,
            toolbar: {
              show: false
            }
          },
          legend: {
            show: false
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              columnWidth: '30%',
              dataLabels: {
                position: 'top',
              },
            }
          },
          dataLabels: {
            enabled: false
          },
          colors: ['#005DFF'],
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },

          xaxis: {
            type: 'category',
            categories: ['5', '4', '3', '2', '1'],
            axisTicks: { show: false },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'light',
              type: "vertical",
              shadeIntensity: 0.25,
              gradientToColors: ['#00D2FF'],
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
            },
          },
          // yaxis: {
          //   min: 0,
          //   max: 4,
          //   title: {
          //   },
          //  labels: {
          //       formatter: function (y) {
          //         return ((y.toFixed(0) * "25" ));
          //       }
          //   }
          // },
          grid: {
            show: true,
            strokeDashArray: 0,
            xaxis: {
              lines: {
                show: false
              }
            },
            yaxis: {
              lines: {
                show: true
              }
            },
          },
          tooltip: {
            marker: {show: false,},
            x: {show: false},
            y: {
              formatter: function (val) {
                return  val
              }
            }
          },
          responsive: [{
            breakpoint: 768,
            options: {
              xaxis: {
                  axisBorder: {
                    show: false,
                },
                labels: {
                      style: {
                      fontSize: "11px"
                      },
                }
              },   
              yaxis: {
                  lines: {
                      show: false
                  }
              },
            } },
            {
              breakpoint: 992,
              options: {
                plotOptions: {
            bar: {
              columnWidth: '50%',
            }},
                xaxis: {
                  labels: {
                        style: {
                        fontSize: '13px'
                        }
                        }
                },
              }
          },
        {
          breakpoint: 376,
          options: {
            grid: {
              show: false,
            },
          }
        }
        ],
        }
    }
  },
}
</script>
<style scoped>
</style>